export default {
  PENDING: 'pending',
  LOADING: 'loading',
  LOADED: 'loaded',
  FAIL: 'fail'
} as Record<string, videoDownloadStatus>
